import { formatCustomCurrency } from '../../../utils/currency/formatAsCurrency';

export function getVariantItemValue(itemValueType, itemValue, itemIsDiscount = false, itemDiscountType = '', interestRate = 0) {
  const decimals = itemValueType === 'CURRENCY' ? 0 : 2;
  if (itemValueType === 'PERCENTAGE' && itemIsDiscount && interestRate !== null) {
    const interestRateDiscount = itemDiscountType === 'VALUE' ? itemValue : interestRate * (itemValue / 100);
    return formatCustomCurrency(interestRate - interestRateDiscount, decimals, false);
  }
  return formatCustomCurrency(itemValue, decimals, false);
}
